import { Moment } from 'moment';
import React, { FC } from 'react';
import styled from 'styled-components';
import history from '../../config/browser-history';
import { URL_DATE_FORMAT } from '../../constants/dates';
import { ordersRoute } from '../../pages/orders/route';
import { DatePickerInputPillStyle } from '../date-range-picker/date-range-input-pill-styles';
import {
  DateRangePicker,
  IDateProps,
} from '../date-range-picker/date-range-picker';

const StyledDateRangeSearchForm = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 0.5rem;

  a {
    font-family: AvenirNext;
    font-size: 1rem;
    margin-top: 0.5rem;
  }
`;

const DateRangePillSearchForm: FC<{
  soldToId: string;
  shipToId?: string;
  startDate: Moment;
  endDate: Moment;
}> = ({ soldToId, shipToId, startDate, endDate }) => {
  const handleDateChange = (value: IDateProps) => {
    if (value && value.startDate && value.endDate) {
      history.push(
        ordersRoute(soldToId, {
          shipToId,
          start: value.startDate.format(URL_DATE_FORMAT),
          end: value.endDate.format(URL_DATE_FORMAT),
        })
      );
    }
  };

  return (
    <StyledDateRangeSearchForm data-type="date-picker">
      <DatePickerInputPillStyle>
        <DateRangePicker
          initialRange={{
            startDate,
            endDate,
          }}
          onChange={handleDateChange}
          anchorDirection="left"
        />
      </DatePickerInputPillStyle>
    </StyledDateRangeSearchForm>
  );
};

export { DateRangePillSearchForm };
